import * as React from "react";
import { styled, ThemeProvider, createTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import CssBaseline from "@mui/material/CssBaseline";
import IconButton from "@mui/material/IconButton";
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import MenuIcon from "@mui/icons-material/Menu";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { useState } from "react";
import isoEventLogoClose from "./../../../assets/images/Logo/Logo-Pazirex-Icon.svg";
import isoEventLogoOpen from "./../../../assets/images/Logo/Logo-Pazirex-White.svg";
import { Link, useNavigate } from "react-router-dom";
import { ReactComponent as ChevronDownIcon } from "./../../../assets/images/icons/Google SVGs/chevron_down.svg";
import { ReactComponent as HomeIcon } from "./../../../assets/images/icons/Google SVGs/home(light).svg";
import { ReactComponent as HomeHealthIcon } from "./../../../assets/images/icons/Google SVGs/home_health.svg";
import { ReactComponent as StethoscopeIcon } from "./../../../assets/images/icons/Google SVGs/stethoscope.svg";
import { ReactComponent as CalendarMonthMineIcon } from "./../../../assets/images/icons/Google SVGs/calendar_month_mine.svg";
import { ReactComponent as CalendarMonthIcon } from "./../../../assets/images/icons/Google SVGs/calendar_month.svg";

// MUI Menu imports
import { alpha } from "@mui/material/styles";
import Menu from "@mui/material/Menu";
// end MUI Menu imports

import isoEventLogo from "./../../../assets/images/Logo/Logo-Pazirex-Blue.svg";
import CalendarAddOnIcon from "./../../../assets/images/icons/Google SVGs/calendar_add_on(light).svg";
import apiConfig from "./../../../utilities/apiConfig.json";
import serverConfig from "./../../../utilities/serverConfig.json";

import "./sidebar.scss";
import { useEffect } from "react";
import IsLogin from "../../../utilities/functions/isLogin";
import { useDispatch, useSelector } from "react-redux";
import { setUser, clearUser } from "../../../slices/userSlice";
import haveAccess from "../../../utilities/functions/haveAccess";
import axios from "axios";

const isMobile = window.innerWidth >= 992 ? false : true;

const theme = createTheme({
  direction: "rtl",
  typography: {
    fontFamily: "IRANSans", // Change this to your desired font family
  },
});
const drawerWidth = window.innerWidth >= 992 ? 208 : 0;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  // ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,

  paddingRight: `calc(${theme.spacing(8)} + 1px)`,

  transition: theme.transitions.create(["width", "padding"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    paddingRight: drawerWidth,
    transition: theme.transitions.create(["width", "padding"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",

  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
  // Adjusted for RTL
  "& .MuiPaper-root": {
    right: 0,
    left: "auto",
  },
}));

// const StyledFab = styled(Fab)({
//   position: "absolute",
//   zIndex: 1051,
//   top: 10,
//   left: "auto",
//   right: drawerWidth - 28,
//   margin: "0 auto",
// });

const MiniDrawer = ({ children }) => {

  const turnTimes = document.querySelector('#turn_times_container');

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { token, roles } = useSelector((state) => state.user);
  const tokenLocal = localStorage.getItem("token");
  const headers = {
    Authorization: "Bearer " + (token ? token : tokenLocal),
  };

  const [open, setOpen] = useState(true);
  const [drawerOpen, setDrawerOpen] = useState(true);
  const [FullName, setFullName] = useState(
    localStorage.getItem("FullName") ? localStorage.FullName : ""
  );

  const handleDrawerOpen = () => {
    if (turnTimes) {
      turnTimes.style.width = `${turnTimes.clientWidth - 143}px`;
    }
    setDrawerOpen(true);
  };

  const handleDrawerClose = () => {
    if (turnTimes) {
      turnTimes.style.width = `${turnTimes.clientWidth + 143}px`;
    }
    setDrawerOpen(false);
  };

  // const handleDrawer = () => {
  //   setDrawerOpen(!drawerOpen);
  // };

  const logoutAPI = () => {
    axios
      .post(
        serverConfig.server.url + apiConfig.api.authControllers.logout,
        {},
        {
          headers,
        }
      )
      .then((response) => {
        if (response.data.status != "error") {
          localStorage.clear();
          dispatch(clearUser());
          window.location.replace("/login");
        }
      })
      .catch((error) => {
        console.error("Error making API call:", error);
      });
  };

  useEffect(() => {
    setFullName(localStorage.getItem("FullName"));
  }, [localStorage.getItem("FullName")]);

  useEffect(() => {
    const checkLoginStatus = async () => {
      try {
        const loggedIn = await IsLogin();
        if (!token && tokenLocal) {
          dispatch(setUser({ token: tokenLocal, roles: loggedIn, hiThere: 12 }));
        }
      } catch (error) {
        console.error("Error checking login status:", error);
      }
    };
    checkLoginStatus();
  }, [localStorage.getItem("FullName")]);

  return (
    <ThemeProvider theme={theme}>
      <Box dir="rtl" sx={{ display: "flex", position: "relative" }}>
        {/* <StyledFab>
          <IconButton
            // color="inherit"
            aria-label="open drawer"
            onClick={handleDrawer}
            edge="start"
            sx={{
              // marginRight: 5,
              ...(open && { display: "none" }),
            }}
          >
            <MenuIcon />
          </IconButton>
        </StyledFab> */}
        <CssBaseline />
        <AppBar
          position="fixed"
          open={drawerOpen}
          sx={{ zIndex: "1050", boxShadow: "0px 0px 20px 0px #0000000D" }}
        >
          <Toolbar
            className="bg-iso-white border-bottom border-bootstrap-gray-300 py-3"
            style={{ height: isMobile ? "68px" : "74px" }}
          >
            {/* where you should create profile dropdown */}
            <IconButton
              // color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              edge="start"
              sx={{
                // marginRight: 5,
                ...(drawerOpen && { display: "none" }),
              }}
            >
              <MenuIcon />
            </IconButton>
            {isMobile && (
              <img
                type="button"
                src={isoEventLogo}
                className="logo-img d-flex"
                alt="..."
                onClick={() => {
                  navigate("/");
                }}
              />
            )}

            <div className="ms-auto">
              {/* MUI Menu */}

              {/* end MUI Menu */}

              <div className="dropdown">
                <div
                  className="btn dropdown-mui background-bootstrap-gray-200 color-bootstrap-gray-800 rounded-3 dropdown-toggle"
                  type="button"
                  id="dropdownMenu"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <ChevronDownIcon width={24} />
                  {FullName && FullName.length > 12
                    ? FullName.substring(0, 12) + "..."
                    : FullName}
                  {!FullName && "....."}
                </div>
                <ul className="dropdown-menu" aria-labelledby="dropdownMenu">
                  {!haveAccess(roles, "main_turns") &&
                    haveAccess(roles, "main_my_turns") && (
                      <li>
                        <button
                          className="dropdown-item"
                          type="button"
                          onClick={() => {
                            navigate("/my-turns");
                          }}
                        >
                          نوبت‌های من
                        </button>
                      </li>
                    )}
                  {haveAccess(roles, "main_turns") && (
                    <li>
                      <button
                        className="dropdown-item"
                        type="button"
                        onClick={() => {
                          navigate("/turns");
                        }}
                      >
                        نوبت‌های مراجعین
                      </button>
                    </li>
                  )}

                  {
                    roles?.length && (roles?.includes("super_admin") || roles?.includes('accountant'))
                    &&
                    <li>
                      <a
                        target="_blank"
                        href={`https://api.pazirex.com/dashboard?token=${token}`}
                        className="dropdown-item"
                        type="button"
                      >
                        داشبورد
                      </a>
                    </li>
                  }

                  <li>
                    <button
                      className="dropdown-item"
                      type="button"
                      onClick={() => {
                        logoutAPI();
                      }}
                    >
                      خروج
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </Toolbar>
        </AppBar>
        <Drawer
          variant="permanent"
          open={drawerOpen}
          sx={{
            "& .MuiPaper-root": {
              background: "linear-gradient(180deg, #343A40 0%, #495159 100%)",
              zIndex: "1050",
            },
          }}
        >
          <DrawerHeader
            className="px-3 justify-content-center position-relative border-bootstrap-gray-600"
            style={{
              height: isMobile ? "68px" : "74px",
              borderBottom: "solid 1px",
            }}
          >
            {drawerOpen ? (
              <div className="d-flex w-fit mx-auto">
                <img src={isoEventLogoClose} className="w-fit me-2" />
                <img src={isoEventLogoOpen} className="w-fit" />
              </div>
            ) : (
              <img src={isoEventLogoClose} className="w-fit" />
            )}
            <IconButton
              className="position-absolute background-bootstrap-gray-800 color-bootstrap-gray-400 rounded-pill"
              style={{ left: "0px" }} // style={{left:'-20px', bottom: '-20px'}}
              onClick={handleDrawerClose}
              sx={{ ...(!drawerOpen && { display: "none" }) }}
            >
              <ChevronRightIcon />
            </IconButton>
          </DrawerHeader>
          <List className="color-bootstrap-gray-400">
            <ListItem disablePadding sx={{ display: "block" }}>
              <ListItemButton
                sx={{
                  minHeight: 48,
                  justifyContent: drawerOpen ? "initial" : "center",
                  px: drawerOpen ? 0 : 2.5,
                }}
              >
                <ListItemIcon
                  className="color-bootstrap-gray-400"
                  sx={{
                    minWidth: 0,
                    mr: drawerOpen ? 2 : "auto",
                    ml: drawerOpen ? "1rem" : "auto",
                    justifyContent: "center",
                  }}
                >
                  <HomeIcon width={24} />
                </ListItemIcon>
                <ListItemText
                  primary={
                    <Link className="nav-link" aria-current="page" to="/">
                      صفحه اصلی
                    </Link>
                  }
                  sx={{ textAlign: "right", opacity: drawerOpen ? 1 : 0 }}
                />
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding sx={{ display: "block" }}>
              <ListItemButton
                sx={{
                  minHeight: 48,
                  justifyContent: drawerOpen ? "initial" : "center",
                  px: drawerOpen ? 0 : 2.5,
                }}
              >
                <ListItemIcon
                  className="color-bootstrap-gray-400"
                  sx={{
                    minWidth: 0,
                    mr: drawerOpen ? 2 : "auto",
                    ml: drawerOpen ? "1rem" : "auto",
                    justifyContent: "center",
                  }}
                >
                  <HomeHealthIcon width={24} alt="" />
                </ListItemIcon>
                <ListItemText
                  primary={
                    <Link
                      className="nav-link"
                      aria-current="page"
                      to="/place-store"
                    >
                      مراکز درمانی
                    </Link>
                  }
                  sx={{ textAlign: "right", opacity: drawerOpen ? 1 : 0 }}
                />
              </ListItemButton>
            </ListItem>

            <ListItem disablePadding sx={{ display: "block" }}>
              <ListItemButton
                sx={{
                  minHeight: 48,
                  justifyContent: drawerOpen ? "initial" : "center",
                  px: drawerOpen ? 0 : 2.5,
                }}
              >
                <ListItemIcon
                  className="color-bootstrap-gray-400"
                  sx={{
                    minWidth: 0,
                    mr: drawerOpen ? 2 : "auto",
                    ml: drawerOpen ? "1rem" : "auto",
                    justifyContent: "center",
                  }}
                >
                  <StethoscopeIcon width={24} alt="" />
                </ListItemIcon>
                <ListItemText
                  primary={
                    <Link
                      className="nav-link"
                      aria-current="page"
                      to="/doctor-store"
                    >
                      پزشکان
                    </Link>
                  }
                  sx={{ textAlign: "right", opacity: drawerOpen ? 1 : 0 }}
                />
              </ListItemButton>
            </ListItem>

            {haveAccess(roles, "menu_set-event") && (
              <ListItem disablePadding sx={{ display: "block" }}>
                <ListItemButton
                  sx={{
                    minHeight: 48,
                    justifyContent: drawerOpen ? "initial" : "center",
                    px: drawerOpen ? 0 : 2.5,
                  }}
                >
                  <ListItemIcon
                    className="color-bootstrap-gray-400"
                    sx={{
                      minWidth: 0,
                      mr: drawerOpen ? 2 : "auto",
                      ml: drawerOpen ? "1rem" : "auto",
                      justifyContent: "center",
                    }}
                  >
                    <img src={CalendarAddOnIcon} />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <Link
                        className="nav-link"
                        // className="nav-link active"
                        aria-current="page"
                        to="/book-appointment"
                      >
                        ثبت نوبت
                      </Link>
                    }
                    sx={{ textAlign: "right", opacity: drawerOpen ? 1 : 0 }}
                  />
                </ListItemButton>
              </ListItem>
            )}
            {haveAccess(roles, "menu_myturns") && (
              <ListItem disablePadding sx={{ display: "block" }}>
                <ListItemButton
                  sx={{
                    minHeight: 48,
                    justifyContent: drawerOpen ? "initial" : "center",
                    px: drawerOpen ? 0 : 2.5,
                  }}
                >
                  <ListItemIcon
                    className="color-bootstrap-gray-400"
                    sx={{
                      minWidth: 0,
                      mr: drawerOpen ? 2 : "auto",
                      ml: drawerOpen ? "1rem" : "auto",
                      justifyContent: "center",
                    }}
                  >
                    <CalendarMonthMineIcon width={24} alt="" />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <Link
                        className="nav-link"
                        aria-current="page"
                        to="/my-turns"
                      >
                        نوبت‌های من
                      </Link>
                    }
                    sx={{ textAlign: "right", opacity: drawerOpen ? 1 : 0 }}
                  />
                </ListItemButton>
              </ListItem>
            )}
            {haveAccess(roles, "menu_turns") && (
              <ListItem disablePadding sx={{ display: "block" }}>
                <ListItemButton
                  sx={{
                    minHeight: 48,
                    justifyContent: drawerOpen ? "initial" : "center",
                    px: drawerOpen ? 0 : 2.5,
                  }}
                >
                  <ListItemIcon
                    className="color-bootstrap-gray-400"
                    sx={{
                      minWidth: 0,
                      mr: drawerOpen ? 2 : "auto",
                      ml: drawerOpen ? "1rem" : "auto",
                      justifyContent: "center",
                    }}
                  >
                    <CalendarMonthIcon width={24} alt="" />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <Link
                        className="nav-link"
                        aria-current="page"
                        to="/turns"
                      >
                        نوبت‌های مراجعین
                      </Link>
                    }
                    sx={{ textAlign: "right", opacity: drawerOpen ? 1 : 0 }}
                  />
                </ListItemButton>
              </ListItem>
            )}
            <ListItem key={213} disablePadding sx={{ display: "block" }}>
              <ListItemButton
                sx={{
                  minHeight: 48,
                  justifyContent: drawerOpen ? "initial" : "center",
                  px: drawerOpen ? 0 : 2.5,
                }}
              >
                <ListItemIcon
                  className="color-bootstrap-gray-400"
                  sx={{
                    minWidth: 0,
                    mr: drawerOpen ? 2 : "auto",
                    ml: drawerOpen ? "1rem" : "auto",
                    justifyContent: "center",
                  }}
                >
                  <ManageAccountsIcon width={24} />
                </ListItemIcon>
                <ListItemText
                  primary={
                    <Link
                      className="nav-link"
                      aria-current="page"
                      to="/profile"
                    >
                      پروفایل من
                    </Link>
                  }
                  sx={{ textAlign: "right", opacity: drawerOpen ? 1 : 0 }}
                />
              </ListItemButton>
            </ListItem>
            {/* {haveAccess(roles, "menu_shift_set") && (
              <ListItem disablePadding sx={{ display: "block" }}>
                <ListItemButton
                  sx={{
                    minHeight: 48,
                    justifyContent: drawerOpen ? "initial" : "center",
                    px: drawerOpen ? 0 : 2.5,
                  }}
                >
                  <ListItemIcon
                    className="color-bootstrap-gray-400"
                    sx={{
                      minWidth: 0,
                      mr: drawerOpen ? 2 : "auto",
                      ml: drawerOpen ? "1rem" : "auto",
                      justifyContent: "center",
                    }}
                  >
                    <img src={CalendarClockIcon} alt="" />
                  </ListItemIcon>
                  <ListItemText
                    primary={"ثبت شیفت‌کاری"}
                    sx={{ textAlign: "right", opacity: drawerOpen ? 1 : 0 }}
                  />
                </ListItemButton>
              </ListItem>
            )} */}
            {/* {haveAccess(roles, "menu_shift_show") && (
              <ListItem disablePadding sx={{ display: "block" }}>
                <ListItemButton
                  sx={{
                    minHeight: 48,
                    justifyContent: drawerOpen ? "initial" : "center",
                    px: drawerOpen ? 0 : 2.5,
                  }}
                >
                  <ListItemIcon
                    className="color-bootstrap-gray-400"
                    sx={{
                      minWidth: 0,
                      mr: drawerOpen ? 2 : "auto",
                      ml: drawerOpen ? "1rem" : "auto",
                      justifyContent: "center",
                    }}
                  >
                    <img src={EarlyOnIcon} alt="" />
                  </ListItemIcon>
                  <ListItemText
                    primary={"نمایش شیفت‌ها"}
                    sx={{ textAlign: "right", opacity: drawerOpen ? 1 : 0 }}
                  />
                </ListItemButton>
              </ListItem>
            )} */}
            {/* {haveAccess(roles, "menu_my_doctor") && (
              <ListItem disablePadding sx={{ display: "block" }}>
                <ListItemButton
                  sx={{
                    minHeight: 48,
                    justifyContent: drawerOpen ? "initial" : "center",
                    px: drawerOpen ? 0 : 2.5,
                  }}
                >
                  <ListItemIcon
                    className="color-bootstrap-gray-400"
                    sx={{
                      minWidth: 0,
                      mr: drawerOpen ? 2 : "auto",
                      ml: drawerOpen ? "1rem" : "auto",
                      justifyContent: "center",
                    }}
                  >
                    <DiversityIcon width={24} />
                  </ListItemIcon>
                  <ListItemText
                    primary={"پزشکان من"}
                    sx={{ textAlign: "right", opacity: drawerOpen ? 1 : 0 }}
                  />
                </ListItemButton>
              </ListItem>
            )} */}
            {/* end of list */}
          </List>
          {/* <Divider className="background-bootstrap-gray-400" /> */}
          {/* <List className="color-bootstrap-gray-400"> */}
          {/* list of links */}
          {/* <ListItem disablePadding sx={{ display: "block" }}>
              <ListItemButton
                sx={{
                  minHeight: 48,
                  justifyContent: drawerOpen ? "initial" : "center",
                  px: drawerOpen ? 0 : 2.5,
                }}
              >
                <ListItemIcon
                  className="color-bootstrap-gray-400"
                  sx={{
                    minWidth: 0,
                    mr: drawerOpen ? 2 : "auto",
                    ml: drawerOpen ? "1rem" : "auto",
                    justifyContent: "center",
                  }}
                >
                  <img src={InfoIcon} alt="" />
                </ListItemIcon>
                <ListItemText
                  primary={"درباره پذیرکس"}
                  sx={{ textAlign: "right", opacity: drawerOpen ? 1 : 0 }}
                />
              </ListItemButton>
            </ListItem> */}
          {/* <ListItem disablePadding sx={{ display: "block" }}>
              <ListItemButton
                sx={{
                  minHeight: 48,
                  justifyContent: drawerOpen ? "initial" : "center",
                  px: drawerOpen ? 0 : 2.5,
                }}
              >
                <ListItemIcon
                  className="color-bootstrap-gray-400"
                  sx={{
                    minWidth: 0,
                    mr: drawerOpen ? 2 : "auto",
                    ml: drawerOpen ? "1rem" : "auto",
                    justifyContent: "center",
                  }}
                >
                  <img src={GavelIcon} alt="" />
                </ListItemIcon>
                <ListItemText
                  primary={"قوانین و ضوابط"}
                  sx={{ textAlign: "right", opacity: drawerOpen ? 1 : 0 }}
                />
              </ListItemButton>
            </ListItem> */}
          {/* end of list */}
          {/* </List> */}
        </Drawer>

        <Box
          className="px-0"
          component="main"
          sx={{
            flexGrow: 1,
            p: 0,
            // ,paddingBottom: "81px"
          }}
        >
          <DrawerHeader />

          {children}
        </Box>
      </Box>
    </ThemeProvider>
  );
};

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === "light"
        ? "rgb(55, 65, 81)"
        : theme.palette.grey[300],
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
    },
  },
}));

export default MiniDrawer;
